module.exports = {
      id: "home-banner-display-usage",
      viewBox: "0 0 648 445",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#home-banner-display-usage",
      toString: function () {
        return this.url;
      }
    }